<template>
    <modal class="modal" printButton downloadButton :close="closeModal" :printStyle="printStyle" :title="title">
        <h3 class="modal__title" slot="modalHeader">
            <i class="uk-icon-lock"></i>
            Залоги
        </h3>
        <div class="modal__body" slot="modalBody" ref="zalogModalContent">
            <zalog-table v-if="!isLoading && list.length" inModal :list="list" :actualDate="actualDate" />
            <loading v-if="isLoading" />
        </div>
        <div class="modal__footer" slot="modalFooter">
            <pagination v-if="pagination" :paginationObj="pagination" :getNewContent="nextPage" />
        </div>
    </modal>
</template>

<script>
import modal from '@/components/ui/modal.vue'
import zalogTable from '@/components/card/zalogLeasing/zalog/zalogTable.vue'
import oldPagination from '@/components/ui/oldPagination/oldPagination.vue'
import loading from '@/components/ui/loading/loading.vue'

export default {
    components: {
        modal,
        zalogTable,
        loading,
        pagination: oldPagination
    },
    props: {
        list: Array,
        pagination: Object,
        printStyle: String,
        title: String
    },
    computed: {
        actualDate() { return this.$store.state.card?.zalogLeasing?.zalog?.updateDate },
        isLoading() { return this.$store.state.card?.zalogLeasing?.zalog?.isLoading }
    },
    methods: {
        nextPage(limit, offset) {
            this.$store.dispatch('card/zalogLeasing/getZalogData', { limit, offset })
        },
        closeModal() { this.$emit('close') }
    }

}
</script>

<style lang="sass" scoped>
.modal
    &__title
        font-family: Arial,Tahoma,sans-serif
        font-weight: 100
        font-size: 24px
    &__body
        padding: 20px
    &__footer
        float: left
</style>